import { EffectivenessEfficiencyBreakdown, ProviderHubFiltersRequestModel, ScoreProviderCountModel } from "@app/projects/network-assessment/provider-hub/interfaces";
import ProviderHubService from "@app/projects/network-assessment/provider-hub/providerHubService";
import { useQuery } from "@tanstack/react-query";
import { useRef } from "react";

export interface EffectivenessEfficiencyBreakdownResult {
  effectivenessData: ScoreProviderCountModel[] | undefined;
  effectivenessHasData: boolean;
  efficiencyData: ScoreProviderCountModel[] | undefined;
  efficiencyHasData: boolean;
  isError: boolean;
  isLoading: boolean;
}

export const EFFECTIVENESS_EFFICIENCY_BREAKDOWN_QUERY_KEY_PREFIX = "pci-dashboard__effectiveness-efficiency-breakdown";

export const useEffectivenessEfficiencyBreakdown = (providerFiltersRequestModel: ProviderHubFiltersRequestModel | null): EffectivenessEfficiencyBreakdownResult => {
  const providerHubService = useRef(new ProviderHubService()).current;

  const queryResult = useQuery<EffectivenessEfficiencyBreakdown>({
    enabled: providerFiltersRequestModel !== null,
    queryFn: async ({ signal }) => providerHubService.getPciDashboardEffectivenessEfficiencyData(providerFiltersRequestModel, signal),
    queryKey: [EFFECTIVENESS_EFFICIENCY_BREAKDOWN_QUERY_KEY_PREFIX, JSON.stringify(providerFiltersRequestModel)],
    staleTime: 5 * 60 * 1000,
  });

  return {
    effectivenessData: queryResult.data?.effectiveness,
    effectivenessHasData: queryResult.isSuccess && queryResult.data.effectiveness.some(x => x.providerCount > 0),
    efficiencyData: queryResult.data?.efficiency,
    efficiencyHasData: queryResult.isSuccess && queryResult.data.efficiency.some(x => x.providerCount > 0),
    isError: queryResult.isError,
    isLoading: queryResult.isFetching,
  }
}